// extracted by mini-css-extract-plugin
export default {"content":"JKOpM","table":"JD41M","hint":"AU_Bm"};